// @flow
import styled from "styled-components";
import colors from "../../assets/css/colors";

export const SocialLink = styled.a`
	align-items: center;
	border: 1px solid ${({ border_color })=> border_color ? border_color : colors.nrlDarkGreen};
	cursor: pointer;
	display: flex;
	height: 25px;
	justify-content: center;
	width: 25px;
	border-radius: 50%;
	transition: all 0.2s;
	
	&:not(:last-child) {
		margin-right: 0.3125rem;
	}
	&:hover {
		background: ${colors.lightGreen};
	}
	
	svg {
		pointer-events: none;
    }
`;

export default SocialLink;


// WEBPACK FOOTER //
// ./src/components/SocialLink/index.js